site.lottery = {
	init: function() {
		var $request;
		$('#lottery_lookup_form').submit(function(e) {
			e.preventDefault();

			var $that = $(this);
			$that.find('input').prop('disabled', true);
			$that.find('.fa').removeClass('hidden');
			$('.box_lottery_lookup .content').addClass('slideout');

			if ($request) {
				$request.abort();
			}

			var $ticketNumber = $that.find('input').val();

			$.ajax({
				url: '/_/moya/lottery/prize/lookup/' + $ticketNumber,
				type: 'POST',
				
				success: function (res) {
					setTimeout(function() {
						$('.box_lottery_lookup .content').removeClass('slideout').html(res);
						$that.find('input').prop('disabled', false);
						$that.find('.fa').addClass('hidden');
					}, 1000);
				},
				error: function() {
					$('.box_lottery_lookup .content').removeClass('slideout').html('<p>Upp hefur komið villa. Vinsamlegast reyndu aftur.</p>');
					$that.find('input').prop('disabled', false);
					$that.find('.fa').addClass('hidden');
				}
			});
		})
	}
};